/**
 * Converts a prop value to pixels.
 */
export function toPx(value: unknown) {
  if (value == null || value === "") return "0px";
  return `${String(value).replace(/px$/, "")}px`;
}

/**
 * Converts pixels to a prop value.
 */
export function fromPx(value?: string) {
  if (value == null || value === "") return 0;
  return Number(value.trim().replace("px", ""));
}
